import { Component, OnInit, OnDestroy } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { AnimationService } from './services/animation.service';
import { SwiperService } from './services/swiper.service';
import { DynamicEffectsService } from './services/dynamic-effects.service';
import { MainInitService } from './services/main-init.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'VeeduPlan';

  constructor(
    private animationService: AnimationService,
    private swiperService: SwiperService,
    private dynamicEffectsService: DynamicEffectsService,
    private mainInitService: MainInitService
  ) {}

  ngOnInit(): void {
    // Initialize touch device detection
    const nav = navigator as any;
    if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (nav.msMaxTouchPoints > 0)) {
      document.body.classList.add('is-touchable');
    }
  }

  ngAfterViewInit(): void {
    // Initialize all effects after view init
    // Use mainInitService which uses jQuery and vendors.min.js for full compatibility
    setTimeout(() => {
      this.mainInitService.init();
      // Also initialize Angular-specific services as fallback
      this.animationService.initAnimations();
      this.swiperService.initSwipers();
      this.dynamicEffectsService.initAllEffects();
    }, 500);
  }

  ngOnDestroy(): void {
    this.mainInitService.destroy();
    this.dynamicEffectsService.destroy();
    this.swiperService.destroySwipers();
  }
}

